<template>
    <div>
        <van-form @submit="onSubmit">
            <van-field v-model="form.company_name" label="公司名称" placeholder="请填写" :rules="[{ required: true, message: '请填写公司名称！' }]"/>
            <van-field v-model="form.department_name" label="部门" placeholder="请填写" :rules="[{ required: true, message: '请填写部门！' }]"/>
            <van-field v-model="form.position_name" label="职位" placeholder="请填写" :rules="[{ required: true, message: '请填写职位！' }]"/>
            <!-- <div class="dep">
                <div class="college"><span>部门及职位</span></div>
                <div class="ipt">
                    <input type="text" placeholder="部门" class="department" v-model="form.department_name">·
                    <input type="text" placeholder="职位" class="position" v-model="form.position_name">
                </div>
                <div class="rules" v-show="rules"></div>
            </div> -->
            <div class="way plc plcgo">
                <van-field
                    readonly
                    clickable
                    label="时间段"
                    :value="form.date"
                    placeholder="选择时间段"
                    @click="timePicker = true"
                    :rules="[{ required: true, message: '请选择时间段！' }]"/>

                <van-popup v-model="timePicker" position="bottom">
                    <time-date
                        show-toolbar
                        v-model="currentDate"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @cancel="timePicker = false"
                        @confirm="timeConfirm"
                    >
                    </time-date>
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <van-field class="money" type="number" @blur="confirm" v-model="form.month_salary" label="月薪(元)" placeholder="请填写" :rules="[{ required: true, message: '请填写月薪！' }]"/>
            <van-field v-model="form.reasons_leaving" label="离职原因" placeholder="请填写" :rules="[{ required: true, message: '请填写离职原因！' }]"/>
            <van-field v-model="form.certifier_people" label="证明人" placeholder="请填写" />
            <van-field v-model="form.certifier_phone" label="证明人电话" placeholder="请填写" />
            <div style="margin: 16px">
                <van-button round block type="danger" native-type="submit">下一步</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { editWorkExpApi, getWorkExpById } from '@/api/interview'
import TimeDate from '@/components/TimeDate'
import { Toast } from 'vant';
    export default {
        data(){
            return {
                form:{},
                timePicker:false, //时间选择器
                minDate: new Date(1900, 5, 15),
                maxDate: new Date(),
                currentDate: new Date(),
                startDate: '',
                endDate: '',
                rules:false,
                id:sessionStorage.getItem("ID") || 0
            }
        },
        created(){
            this.getWorkExpById()
        },
        methods:{
            // 详情
            getWorkExpById(){
                getWorkExpById({id:this.$route.query.id}).then(res=>{
                    if(res.errNo == 0){
                        this.form = res.result
                        console.log(Object.keys(res.result.certifier_info),'s')
                        this.form.certifier_people = Object.keys(res.result.certifier_info)[0] || ''
                        this.form.certifier_phone = Object.values(res.result.certifier_info)[0] || ''
                        if(res.result.start_date&&res.result.end_date){
                            this.form.date = res.result.start_date + '-' + res.result.end_date
                            this.form.start_date=res.result.start_date
                            this.form.end_date=res.result.end_date
                        }
                        console.log(this.form,'this.form')
                    }
                })
            },
            confirm(){
                if(this.form.month_salary<1000){
                    Toast('请输入正确的薪资');
                    this.form.month_salary = ''
                }
            },
            onSubmit(){
                console.log(this.form,'this.form')
                if(!this.form.department_name){
                    this.rules = true
                    return;
                }
                if(!this.form.position_name){
                    this.rules = true
                    return;
                }

                // 下方时间+字符串'-01'是用来方便后端数据处理
                if(this.form.start_date){
                    this.form.start_date = this.form.start_date+'-01'
                    this.form.end_date = this.form.end_date+'-01'
                }
                const params = {
                    resume_id:this.id,
                    ...this.form,
                    certifier_info:JSON.stringify({[this.form.certifier_people]:this.form.certifier_phone})
                }
                editWorkExpApi(params).then(res=>{
                    if(res.errNo===0){
                        this.$router.push({path:"/interviews/worklist",query:{edit:this.$route.query.edit}})
                    } else {
                        Toast('提交失败,请检查填写信息');
                    }
                })
                // this.$router.push({path:"worklist",query:{...params}})
            },
            // 时间段选择器
            timeConfirm(value, index) {
                this.startDate = value.slice(0,2).join('-');
                this.endDate = value.slice(3,6).join('-');
                this.form.date = this.startDate + '-' + this.endDate;
                this.form.start_date=this.startDate
                this.form.end_date=this.endDate
                this.timePicker = false
            },
            // 验证手机号
            validator(val) {
                const phone = val.split(" ");
                const reg =
                    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                return reg.test(phone.join(""));
            },
        },
        components:{
            TimeDate
        }
    }
</script>

<style scoped lang="less">
.dep {
    padding: 0 4.2%;
    position: relative;
    .college {
        height: 30px;
        line-height: 30px;
        font-size: 26px;
        padding-top: 20px;
        padding-bottom: 10px;
        color: #646566;
    }
    .ipt {
        height: 50px;
        padding-bottom: 10px;
        input {
            height: 50px;
            &::placeholder{
                color: #c8c9cc;
            }
        }
        .department {
            width: 12%;
        }
        .position {
            &::placeholder{
                padding-left: 10px;
            }
        }
    }
    &::after {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 30px;
        bottom: 0;
        left: 30px;
        border-bottom: 1px solid #999999;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
    }
}
.rules {
    color: #ee0a24;
    padding-bottom: 20px;
}
/deep/ .van-cell {
  display: block;
}
/deep/ .van-field__error-message {
  text-align: center;
}
/deep/ .van-cell::after {
  border-bottom: 1px solid #999999;
}
.plc {
    position: relative;
    &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 30px;
    bottom: 0;
    left: 30px;
    border-bottom: 1px solid #999999;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

.plcgo {
    img {
        width: 18px;
        height: 31px;
        position: absolute;
        right: 30px;
        top: 54px;
    }
}
/deep/ .van-image{
    width: 100px;
    height: 100px;
    img{
        border-radius: 50%;
    }
}
/deep/ .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
/deep/ .van-button--block {
  border-radius: 10px;
}
</style>
